import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const problems = [
  "Kvartira qidirish uchun ko'p vaqt sarflanadi",
  "Narxlar noaniq, yashirin to'lovlar mavjud",
  "Qurilish jarayonini kuzatib bo'lmaydi",
  "Shartnoma tuzish murakkab va uzoq",
  "Ishonchli quruvchini topish qiyin",
  "Ipoteka hisoblash chalkash va noqulay",
];

const solutions = [
  "Smart filtr bilan bir necha soniyada toping",
  "Barcha narxlar shaffof va tushunarli",
  "Real vaqtda qurilish jarayonini kuzating",
  "5 bosqichda onlayn shartnoma tuzing",
  "Barcha quruvchilar tekshirilgan va tasdiqlangan",
  "AI kalkulyator bilan ipotekani hisoblang",
];

const ProblemSolution = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.15 });

  return (
    <section className="ps-section section-container" ref={ref}>
      <div style={{ textAlign: 'center', marginBottom: 16 }}>
        <span className="section-tag">Muammo va Yechim</span>
      </div>
      <h2 className="section-title" style={{ textAlign: 'center' }}>
        Nimaga <span className="gold-text">OSTONA</span> kerak?
      </h2>

      <div className="ps-grid">
        <motion.div
          className="ps-card ps-card-problem"
          initial={{ opacity: 0, x: -40 }}
          animate={inView ? { opacity: 1, x: 0 } : {}}
          transition={{ duration: 0.6, ease: 'easeOut' }}
        >
          <span className="ps-card-tag">MUAMMO</span>
          <h3 className="ps-card-title">Hozirgi holat...</h3>
          <div className="ps-list">
            {problems.map((item, i) => (
              <div className="ps-list-item" key={i}>
                <span className="ps-icon">✕</span>
                <span>{item}</span>
              </div>
            ))}
          </div>
        </motion.div>

        <motion.div
          className="ps-card ps-card-solution"
          initial={{ opacity: 0, x: 40 }}
          animate={inView ? { opacity: 1, x: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.15, ease: 'easeOut' }}
        >
          <span className="ps-card-tag">YECHIM</span>
          <h3 className="ps-card-title">OSTONA bilan...</h3>
          <div className="ps-list">
            {solutions.map((item, i) => (
              <div className="ps-list-item" key={i}>
                <span className="ps-icon">✓</span>
                <span>{item}</span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ProblemSolution;
